export const SET_LOADING = 'src/store/ticketManagement/SET_LOADING'
export const SET_SAVE_LOADING = 'src/store/ticketManagement/SET_SAVE_LOADING'
export const SET_SUPPORTER = 'src/store/ticketManagement/SET_SUPPORTER'
export const SET_VIP = 'src/store/ticketManagement/SET_VIP'
export const SET_SUPPORTER_RESPONSE = 'src/store/ticketManagement/SET_SUPPORTER_RESPONSE'
export const SET_VIP_RESPONSE = 'src/store/ticketManagement/SET_VIP_RESPONSE'
export const SET_SOLD_TICKET = 'src/store/ticketManagement/SET_SOLD_TICKET'
export const SET_RESEND_TICKET = 'src/store/ticketManagement/SET_RESEND_TICKET'

